import Auth from "@aws-amplify/auth";
import Axios from 'axios';
import UAParser from 'ua-parser-js';

export const setAuthorizationHeader = async () => {      
  return Auth.currentSession()
        .then((response) => {
              Axios.defaults.headers.common = {
                  Authorization: response.idToken.jwtToken,
              };
        })
        .catch((error) => {
          console.log(error);
      });
}


export const getIPInfo = async () => {
  const { data } = await Axios.get('https://api.ipify.org/?format=json');
  return data;
}

export const getDeviceInfo = () => {
  const info = new UAParser().getResult();
  const { browser, device, os } = info;
  if( device.model ){
    return {
      device: `${device.vendor} ${device.model} | ${os.name} ${os.version}`,
      browser: `${browser.name} ${browser.version}`,
      isMobile: true
    }
  }
  return {
    device: 'web',
    browser: `${browser.name} ${browser.version}`,
    isMobile: false
  }
}

